import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M4.99968 4.10832L14.9997 4.10832C15.4417 4.10832 15.8656 4.28391 16.1782 4.59647C16.4907 4.90903 16.6663 5.33296 16.6663 5.77498L16.6663 15.775C16.6663 16.217 16.4907 16.6409 16.1782 16.9535C15.8656 17.2661 15.4417 17.4417 14.9997 17.4417L4.99967 17.4417C4.55765 17.4417 4.13372 17.2661 3.82116 16.9535C3.5086 16.6409 3.33301 16.217 3.33301 15.775L3.33301 5.77498C3.33301 5.33296 3.5086 4.90903 3.82116 4.59647C4.13372 4.28391 4.55765 4.10832 4.99968 4.10832Z",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.5 4.10832L12.5 17.4417",
  stroke: "#9A91D3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }